import Passwords from '@/resources/passwords';

export default {
  namespaced: true,
  state: {},
  actions: {
    reset(_, { email }) {
      return Passwords.save({}, { email });
    },
    change(_, { password, resetPasswordToken }) {
      return Passwords.update({}, { password, resetPasswordToken });
    }
  }
};
